var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[_c('PaymentMixCredit',{attrs:{"grossTotal":_vm.grossTotal,"totalItems":_vm.totalItems}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }